import { useTranslation } from "react-i18next";
import { LoadingPanel, ErrorPanel } from "components/panels";

import { useAcpFeedPreview } from "../hooks/useAcpFeedPreview";
import { AcpFeedPreviewSection } from "./AcpFeedPreviewSection";

export const AcpTabContent = () => {
  const { t } = useTranslation(["productDetails"]);
  const { data, isLoading, error } = useAcpFeedPreview();

  if (isLoading) {
    return <LoadingPanel loadingText={t("productDetails:rawData.loading")} />;
  }

  if (error) {
    return (
      <ErrorPanel
        title={t("productDetails:rawData.acp.title")}
        errorTitle={t("productDetails:rawData.error.title")}
        errorMessage={t("productDetails:rawData.error.message")}
      />
    );
  }

  if (!data) return null;

  return (
    <div data-testid="acp-feed-preview-section">
      <AcpFeedPreviewSection data={data} />
    </div>
  );
};
